import Stack from '@mui/material/Stack';
import type { PropsWithChildren } from 'react';
import React from 'react';

export const Actions: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack direction="row" spacing={2} sx={{
      alignItems: "end"
    }}>
      {children}
    </Stack>
  );
};
